import '../../../common/dashboard/filters/unapplied/unapplied_filter_view.js.coffee'
import '../../../common/dashboard/filters/fixed_string_filters_mixin.js.coffee'

Namespace 'CustomerVisualMode.Filters.Unapplied'

class CustomerVisualMode.Filters.Unapplied.UnappliedTicketAttributesFiltersView extends
Common.Dashboard.Filters.UnappliedFilterView
  template: JST['backbone/templates/common/dashboard/filters/unapplied/unapplied_ticket_attributes_filters']

  initialize: ({filter, ticketAttributeDefinitions}) ->
    super(filter: filter)
    _.extend(@, Common.Dashboard.Filters.FixedStringFiltersMixin)
    @attributes = ticketAttributeDefinitions
    @listenTo(@attributes, 'update', @render)
    @filterViews = []
    @lastAppliedFilter = {}

  render: =>
    @filterViews.forEach((view) -> view.remove())
    @filterViews = @_attributeFiltersToDisplay().map(@_createAttributeFilterView)
    return @ if @filterViews.length == 0
    @$el.html(@template())
    @filterViews.forEach (view) =>
      @listenTo(view, 'filter:apply', (values) =>
        @lastAppliedFilter = {}
        @lastAppliedFilter[view.attributeCode()] = values
        @applyFilter()
      )
      @$('.unapplied-ticket-attributes-filters-container').append(view.render().el)
    @

  _attributeFiltersToDisplay: ->
    _.select @_attributeFilters(), @_shouldDisplayAttributeFilter

  _canFilterByAttribute: (attribute) ->
    attribute.isFixedString() || attribute.isHierarchicalTags()

  _attributeFilters: ->
    @attributes.select(@_canFilterByAttribute).map(@_createAttributeFilter)

  _createAttributeFilter: (attribute) =>
    attributeFilter = switch
      when attribute.isFixedString() then CustomerVisualMode.Filters.FixedStringAttributeFilter
      when attribute.isHierarchicalTags() then CustomerVisualMode.Filters.HierarchicalTagsAttributeFilter
    new attributeFilter
      attribute: attribute
      values: @_attributeValues attribute

  _shouldDisplayAttributeFilter: (filter) =>
    filter.isReappliable() or not @_attributeFilterIsApplied(filter)

  _attributeFilterIsApplied: (attributeFilter) ->
    @filter.appliedAttributeCodes().includes attributeFilter.getCode()

  _createAttributeFilterView: (filter) ->
    FILTER = CustomerVisualMode.Filters
    attributeFilterView = switch filter.getFilterType()
      when FILTER.FixedStringAttributeFilter.FILTER_TYPE then FILTER.Unapplied.UnappliedFixedStringFilterView
      when FILTER.HierarchicalTagsAttributeFilter.FILTER_TYPE then FILTER.Unapplied.UnappliedHierarchicalTagsFilterView
    new attributeFilterView({filter})

  _attributeValues: (attribute) ->
    @filter._valuesToJSON()[attribute.get('code')] || []
